import { apiClient } from './AbstractHTTPService'

const PATH = '/module/'

export default {
  getPermissionOptions () {
    return apiClient.get(PATH + 'permission/')
  },

  getModules () {
    return apiClient.get(PATH)
  },

  getDateModules () {
    return apiClient.get(PATH + 'dates/')
  },

  getPermissions () {
    return apiClient.get('/modulepermission/')
  },

  getPermissiongroupes () {
    return apiClient.get('/permissiongroupe/user/')
  }

}
